import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';


// error
import Error400 from '../pages/error/error400';
import Error401 from '../pages/error/error401';
import Error403 from '../pages/error/error403';
import Error404 from '../pages/error/error404';
import Error500 from '../pages/error/error500';
import Error503 from '../pages/error/error503';

import events from '../pages/running/events.vue'
import event_team from '../pages/running/event_team.vue'
import eventsDetail from '../pages/running/event_detail.vue'

import events_detail_wholesale from '../pages/running/event_detail_wholesale.vue'
import events_detail_manual from '../pages/running/event_detail_manual.vue'
import events_detail_package from '../pages/running/event_detail_package.vue'
import event_highlight_promote from '../pages/running/event_highlight_promote.vue'
import events_detail_coupon from '../pages/running/event_detail_coupon.vue'
import events_detail_coupon_order from '../pages/running/event_detail_coupon_order.vue'
import cart from '../pages/running/cart.vue'
import cart_wholesale from '../pages/running/cart_wholesale.vue'
import cart_manual from '../pages/running/cart_manual.vue'
import cart_package from '../pages/running/cart_package.vue'
import eventqr from '../pages/running/eventqr.vue'
import qr from '../pages/running/eventqr.vue'
import download from '../pages/running/download.vue'
import d from '../pages/running/download.vue'
import dd from '../pages/running/download_direct.vue'

import howToOrder from '../pages/running/how_to_order.vue'
import findOrder from '../pages/running/findOrder.vue';
import find_mobile from '../pages/running/find_mobile.vue';
import about from '../pages/running/about.vue';
import terms_of_use from '../pages/running/terms_of_use.vue';
import how_to_use from '../pages/running/how_to_use.vue';
import refund_policy from '../pages/running/refund_policy.vue'
import how_to_get_additional_images from '../pages/running/how_to_get_additional_images.vue'

const routes = [
  {
    path: '/',
    component: Body,

    children: [
      {
        path: '',
        name: 'events',
        component: events,
        meta: {
          title: 'ค้นหารูปความประทับใจด้วยใบหน้า | RUNNING.IN.TH',
        }
      }, 
      {
        path: 'team/:team_key',
        name: 'event_team',
        component: event_team,
        meta: {
          title: 'ค้นหารูปความประทับใจด้วยใบหน้า | RUNNING.IN.TH',
        }
      },
      {
        path: ':event_key/hl',
        name: 'event_highlight_promote',
        component: event_highlight_promote,
        meta: {
          title: 'สร้างภาพโปรโมต | RUNNING.IN.TH',
        }
      },
      {
        path: ':event_id',
        name: 'eventsDetail',
        component: eventsDetail,
        meta: {
          title: 'รูปงานวิ่ง | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: ':event_id/wholesale',
        name: 'events_detail_wholesale',
        component: events_detail_wholesale,
        meta: {
          title: 'ภาพวิ่งราคาเหมาๆ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      }, 
      {
        path: ':event_id/manual',
        name: 'events_detail_manual',
        component: events_detail_manual,
      },
      {
        path: ':event_id/package',
        name: 'events_detail_package',
        component: events_detail_package,
      },
      {
        path: ':event_id/coupon',
        name: 'events_detail_coupon',
        component: events_detail_coupon,
        meta: {
          title: 'ซื้อคูปองราคาพิเศษ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/coupon/:uuid',
        name: 'events_detail_coupon_order',
        component: events_detail_coupon_order,
        meta: {
          title: 'รายละเอียดคูปอง | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: "cart",
        name: "cart",
        component: cart,
        meta: {
          title: "ตะกร้า | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน",
        },

      },
      {
        path: "cart-manual",
        name: "cart_manual",
        component: cart_manual,
        meta: {
          title: "ตะกร้า | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน",
        },
      },
      {
        path: "cart-package",
        name: "cart_package",
        component: cart_package,
        meta: {
          title: "ตะกร้า Package | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน",
        },
      },{
        path: "cart-wholesale",
        name: "cart_wholesale",
        component: cart_wholesale,
        meta: {
          title: "ภาพวิ่งเหมาๆ ตะกร้า | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน",
        },

      },
      {
        path: "how-to-order",
        name: "howToOrder",
        component: howToOrder,
        meta: {
          title: "วิธีการสั่งซื้อรูปภาพ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน",
        },
      },
       
      {
        path: ':q/qr',
        name: 'qr',
        component: qr,
        meta: {
          title: 'QR | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/download/:q',
        name: 'download',
        component: download,
        meta: {
          title: 'โหลดรูปภาพ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/d/:q',
        name: 'd',
        component: d,
        meta: {
          title: 'โหลดรูปภาพ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/dd/:q',
        name: 'dd',
        component: dd,
        meta: {
          title: 'โหลดรูปภาพ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/about',
        name: 'about',
        component: about,
        meta: {
          title: 'เกี่ยวกับเรา | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      }, 
      {
        path: '/find-order',
        component: findOrder,
        name: 'findOrder',
        meta: {
          title: 'ค้นหาคำสั่งซื้อ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/terms-of-use',
        name: 'terms-of-use',
        component: terms_of_use,
        meta: {
          title: 'ข้อตกลงการใช้บริการ และ นโยบายความเป็นส่วนตัว | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/refund-policy',
        name: 'refund-policy',
        component: refund_policy,
        meta: {
          title: 'นโยบายการคืนเงิน | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/how-to-get-additional-images',
        name: 'how-to-get-additional-images',
        component: how_to_get_additional_images,
        meta: {
          title: 'วิธีการรับภาพเพิ่มเติม | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      {
        path: '/how-to-use',
        name: 'how-to-use',
        component: how_to_use,
        meta: {
          title: 'วิธีการโหลดภาพ | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },
      
      {
        path: '/404',
        name: '404',
        component: Error404,
        meta: {
          title: 'Page not found | RUNNING.IN.TH ค้นง่าย หาเจอแน่นอน',
        }
      },

    ]
  },
]
const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router